var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9304 12.9307V15.4827C12.9301 15.9473 12.7454 16.3928 12.417 16.7213C12.0885 17.0499 11.6431 17.2347 11.1786 17.2351H2.75368C2.28879 17.2351 1.84293 17.0505 1.51409 16.7219C1.18525 16.3933 1.00034 15.9476 1 15.4827V7.05783C1.00024 6.59307 1.18496 6.14741 1.51358 5.81876C1.84219 5.49011 2.28783 5.30534 2.75259 5.30505H5.24336",
    stroke: "#8192AA",
    strokeWidth: 1.34783,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4217 1H6.99625C6.02832 1 5.24365 1.78466 5.24365 2.75259V11.178C5.24365 12.146 6.02832 12.9306 6.99625 12.9306H15.4217C16.3896 12.9306 17.1743 12.146 17.1743 11.178V2.75259C17.1743 1.78466 16.3896 1 15.4217 1Z",
    stroke: "#8192AA",
    strokeWidth: 1.34783,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copy icon.174eb3114fb961ef231759097bd0fcae.svg";
export { ForwardRef as ReactComponent };